export const IMAGE_CROP_TYPE = {
  SQUARE: "square",
  RECTANGLE: "rectangle",
  INSTAGRAM: "instagram",
  THUMBNAIL: "thumbnail",
}
